import _toConsumableArray from "D:/coding/pmv5-fe/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import Axios from "axios";
import padEnd from "pad-end";
// import download from "downloadjs";
import { Notice } from "iview";
import { downloadFromUrl } from '@/utils/shared.js';

// from novnc webutil.js
function getQueryVar(name, defVal) {
  "use strict";

  var re = new RegExp(".*[?&]" + name + "=([^&#]*)"),
    match = document.location.href.match(re);
  if (typeof defVal === "undefined") {
    defVal = null;
  }
  if (match) {
    return decodeURIComponent(match[1]);
  } else {
    return defVal;
  }
}
/**
 * 将激活码、SN 等格式化成 XXXX XXXX XXXX 格式
 * @param {String} text 激活码字符串
 * @param {Number} len 激活码最大长度
 * @param {Number} size 格式化后每个部分的长度
 */
function formatCode(text, len, size) {
  if (arguments.length === 2) {
    size = len;
    len = text.length;
  }
  if (text.length < len) {
    text = padEnd(text, len, "0");
  } else {
    text = text.substr(0, len);
  }
  var truncateArray = [];
  while (text.length > 0) {
    truncateArray.push(text.substr(0, size));
    text = text.substring(size);
  }
  return truncateArray.join(" ");
}
export default {
  name: "activation-app",
  data: function data() {
    var mcd = getQueryVar("mcd");
    return {
      productId: "",
      // machineCodeFrom: mcd ? "file" : "input",
      machineCodeFrom: "file",
      hideFrom: !!mcd,
      machineCode: mcd,
      loading: false,
      fileNames: []
    };
  },
  computed: {
    formatProductId: function formatProductId() {
      var id = this.productId;
      return formatCode(id, 16, 4);
    }
  },
  methods: {
    isValid: function isValid() {
      var valid = Boolean(this.productId);
      if (this.machineCodeFrom === "file") {
        valid = valid && Boolean(this.$refs.fileInput.files[0]);
      } else {
        // valid = valid && Boolean(this.machineCode);
        valid = valid && typeof this.machineCode === 'string' && /^\S+$/.test(this.machineCode);
      }
      return valid;
    },
    submit: function submit() {
      var _this = this;
      var data;
      if (this.machineCodeFrom === "file") {
        data = new FormData();
        data.append("sn", this.productId);
        // for (let file of this.selectedFiles) {
        //     data.append("mcd", file);
        // }

        var reg = /\.\w+$/;
        var len = this.selectedFiles.length;
        var file;
        for (var index = 0; index < len; index++) {
          file = this.selectedFiles[index];
          var match = file.name.match(reg);
          if (match === null || match[0] !== '.mcd' && match[0] !== '.dat') {
            Notice.error({
              title: "错误",
              desc: "\u7B2C".concat(index + 1, "\u4E2A\u6587\u4EF6\u683C\u5F0F\u6709\u8BEF\uFF01\u53EA\u80FD\u4E3A.mcd\u6216.dat\u6587\u4EF6\uFF01")
            });
            return false;
          }
          data.append("mcd", file);
        }
      } else {
        data = {
          mcd: this.machineCode,
          sn: this.productId
        };
      }
      this.loading = true;
      Axios.post("/pmv5/service/activation/file/", data, {
        silent: true
      }).then(function (resp) {
        var message = resp.data.message;
        if (resp.status !== 200) {
          Notice.error({
            title: "错误",
            desc: message || "后端服务异常"
          });
          _this.loading = false;
          return false;
        }

        // let header = Object.keys(resp.headers).filter(name => /^content-disposition$/i.test(name))[0];
        // let name = "file.dat";
        // if (header) {
        //     let value = resp.headers[header];
        //     name = value.split("; ").filter(p => p.indexOf("filename") > -1)[0].replace(/filename="([^"]+)"/, "$1");
        // }
        // download(resp.data, name, "application/octet-stream");

        downloadFromUrl("/pmv5/service/fenxiang/files/?no=".concat(_this.productId));
        _this.loading = false;
      }, function (e) {
        _this.loading = false;
        throw e;
      });
    },
    filterNumbers: function filterNumbers() {
      var _this2 = this;
      var oldId = this.productId;
      var filteredId = oldId.replace(/[^0-9]+/g, "");
      if (oldId !== filteredId) {
        this.$nextTick(function () {
          return _this2.productId = filteredId;
        });
      }
    },
    updateFiles: function updateFiles() {
      if (!this.selectedFiles) {
        this.selectedFiles = [];
      }
      var files = this.selectedFiles;
      files.push.apply(files, _toConsumableArray(this.$refs.fileInput.files));
      this.fileNames = files.map(function (f) {
        return f.name;
      });
    },
    removeFile: function removeFile(name) {
      var i = this.fileNames.indexOf(name);
      if (i === -1) {
        return;
      }
      this.fileNames.splice(i, 1);
      this.selectedFiles.splice(i, 1);
    }
  }
};